// extracted by mini-css-extract-plugin
export var category = "_kw-9";
export var categoryHeader = "_kw-e";
export var container = "_kw-0";
export var group = "_kw-a";
export var groupItems = "_kw-f";
export var groupSeparator = "_kw-j";
export var loading = "_kw-1";
export var noResults = "_kw-3";
export var placeholder = "_kw-2";
export var resultContent = "_kw-5";
export var resultIcon = "_kw-c";
export var resultItem = "_kw-g";
export var resultMeta = "_kw-8";
export var resultSubtitle = "_kw-7";
export var resultSuffix = "_kw-i";
export var resultTitle = "_kw-6";
export var resultsList = "_kw-4";
export var searchGroup = "_kw-d";
export var selected = "_kw-h";
export var subgroup = "_kw-b";